// extracted by mini-css-extract-plugin
var _1 = "PageFooter__PageFooter--yI25Y";
export { _1 as "PageFooter" }
